import brandConfig from './branding'

export default brandConfig
